module.exports = __webpack_public_path__ + "static/media/plate2Bg.247f2293.png";